import type { ActionCard, AskUserAnswers } from '@littlebird/sdk';

export const findAskUserCard = (
  cards: readonly ActionCard[],
  requestId: string
): ActionCard | undefined =>
  cards.find(
    (card) =>
      !card.deletedAt &&
      card.actionType === 'ask_user' &&
      card.content.request_id === requestId
  );

export const SKIPPED_LABEL = 'Skipped';

export type AnswerRow = {
  questionId: string;
  prompt: string;
  answer: string;
  skipped: boolean;
};

export function answerLabel(answer: {
  selected: string[];
  freeText?: string | null;
  skipped: boolean;
}): string {
  if (answer.skipped) return SKIPPED_LABEL;
  const parts = [...answer.selected];
  if (answer.freeText) parts.push(answer.freeText);
  return parts.join(', ') || SKIPPED_LABEL;
}

export function toAnswerRows(answers: AskUserAnswers): AnswerRow[] {
  return answers.items
    .filter((item) => item.prompt)
    .map((item) => ({
      questionId: item.question_id,
      prompt: item.prompt!,
      answer: answerLabel({
        selected: item.selected,
        freeText: item.free_text,
        skipped: item.skipped,
      }),
      skipped: item.skipped || (!item.selected.length && !item.free_text),
    }));
}
